<template>
  <div class="page-sign-detail">
    <van-form @submit="onSubmit">
      <van-field v-model="detailData.policyNo" border readonly name="保单号" label="保单号" />
      <van-field v-model="detailData.productName" readonly name="产品名称" label="产品名称" />
      <van-field v-model="detailData.userName" readonly name="投/被保人" label="投/被保人" />
      <van-field v-model="detailData.salesmanName" readonly name="业务员" label="业务员" />
      <van-field name="客户签收方式" label="客户签收方式" required>
        <template #input>
          <van-radio-group v-model="formData.signType" direction="horizontal">
            <van-radio :name="1" icon-size="16">当面递交</van-radio>
            <van-radio :name="2" icon-size="16">快递寄送</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <template v-if="formData.signType == 1">
        <van-field v-model="formData.sendName" required name="递交人员" label="递交人员" placeholder="请输入" />
        <van-field
          readonly
          clickable
          name="calendar"
          :value="formData.signDate"
          label="签收日期"
          placeholder="点击选择日期"
          required
          @click="showCalendar = true"
        />
        <van-calendar v-model="showCalendar" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" />
        <van-field v-model="formData.signAddress" required type="textarea" name="签收地址" label="签收地址" placeholder="请输入" />
      </template>
      <template v-if="formData.signType == 2">
        <van-field v-model="formData.signMailCompany" required name="快递公司" label="快递公司" placeholder="请输入" />
        <van-field v-model="formData.signMailOrderNo" required name="快递单号" label="快递单号" placeholder="请输入" />
      </template>
      <div class="btn-box">
        <van-button block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <app-loading :loaded="loaded"></app-loading>
  </div>
</template>

<script>
import loading from '@/components/loading';
export default {
  components: {
    'app-loading': loading
  },
  props: {},
  data() {
    return {
      loaded: true,
      detailData: '',
      showCalendar: false,
      formData: {
        signType: '',
        sendName: '',
        signDate: '',
        signAddress: '',
        signMailCompany: '',
        signMailOrderNo: ''
      },
      minDate: new Date(2010, 0, 1), // 设置最小日期为2020年1月1日
      maxDate: new Date() // 设置最大日期为当前日期
    };
  },
  watch: {},
  computed: {},
  methods: {
    onSubmit() {
      if (!this.formData.signType) {
        Toast('请选择签收方式');
        return;
      }
      const rules = {
        1: [
          { field: 'sendName', message: '递交人员不能为空' },
          { field: 'signDate', message: '签收日期不能为空' },
          { field: 'signAddress', message: '签收地址不能为空' }
        ],
        2: [
          { field: 'signMailCompany', message: '快递公司不能为空' },
          { field: 'signMailOrderNo', message: '快递单号不能为空' }
        ]
      };

      const currentRules = rules[this.formData.signType] || [];
      for (const rule of currentRules) {
        if (!this.formData[rule.field]) {
          this.$notice.msg(rule.message);
          return;
        }
      }
      this.loaded = false;
      const params = {
        sign: this.$route.query.sign,
        id: this.$route.query.id,
        signType: this.formData.signType,
        isFillsignInfo: 1
      };
      if (this.formData.signType == 1) {
        params.sendName = this.formData.sendName;
        params.signDate = this.formData.signDate;
        params.signAddress = this.formData.signAddress;
      }
      if (this.formData.signType == 2) {
        params.signMailCompany = this.formData.signMailCompany;
        params.signMailOrderNo = this.formData.signMailOrderNo;
      }
      this.$http({
        type: 'POST',
        url: '/api/content/updatePaperPolicy',
        data: params
      })
        .then(res => {
          console.log(res);
          this.loaded = true;
          this.$notice.msg('提交成功');
          this.$router.push({
            name: 'apps.policys.paperPolicy/signList',
            query: {
              sign: this.$route.query.sign
            }
          });
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    onConfirm(date) {
      this.formData.signDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      this.showCalendar = false;
    }
  },
  created() {
    this.detailData = JSON.parse(sessionStorage.getItem('paperSignDetail'));
    this.detailData.userName = `${this.detailData.policyerName}/${this.detailData.insuranceName}`;
    Object.keys(this.formData).forEach(key => {
      this.formData[key] = this.detailData[key];
    });
    console.log(this.formData);
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-sign-detail {
  min-height: 100vh;
  background-color: #fff;
}
.van-cell:not(:last-child)::after {
  display: block !important;
  border-bottom: 1px solid #ebedf0;
}
.btn-box {
  padding: 200px 30px 0;
}
</style>